import React, { Component } from "react";
import PropTypes from "prop-types";

import CheckBox from "./Checkbox";

export class CheckBoxList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onChange: null,
      options: props.options.map((o) => {
        return {
          key: o.value,
          name: o.name,
          checked: this.props.values
            ? this.props.values.includes(o.value)
            : false,
        };
      }),
    };
  }

  render() {
    return (
      <div className="checkbox-list">
        {this.state.options.map((o) => (
          <div className="checkbox-list-option" key={o.key}>
            <CheckBox
              className="checkbox-list-option-box"
              id={o.key}
              key={o.key}
              name={o.key}
              checked={o.checked}
              onChange={(e) => this.onChange(e.target.name, !o.checked)}
              defaultValue={false}
            />
            {o.name}
          </div>
        ))}
      </div>
    );
  }

  onChange(key, value) {
    let newOptions = [...this.state.options];
    if (key === "None" && value === true) {
      newOptions.forEach((option) => (option.checked = false));
      newOptions.find((option) => option.key === "None").checked = true;
    } else if (newOptions.find((option) => option.key === "None")) {
      newOptions.find((option) => option.key === key).checked = value;
      newOptions.find((option) => option.key === "None").checked = false;
    } else {
      //checkbox list has no "None of the above" option
      newOptions.find((option) => option.key === `${key}`).checked = value;
    }

    this.setState({ options: newOptions });

    if (this.props.onChange) {
      let newValue = newOptions.filter((o) => o.checked).map((o) => o.key);
      this.props.onChange(newValue);
    }
  }
}

CheckBoxList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.any.isRequired,
      name: PropTypes.any.isRequired,
      checked: PropTypes.bool,
    })
  ),
};
